import { useReactFlow as u } from '@xyflow/react'
import { logger } from 'v2/utils/logger'
import type { GenericEdge, GenericNode } from '../types'

export const useTypedReactFlow = u<GenericNode, GenericEdge>
logger.log('useReactFlow initialized')
